function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { CloseButton } from '../CloseButton';
import { Link } from '../Link';
import styles from '@dtsl/css-alert/dist/index.module.css';
import Error from '@dtsl/icons/dist/icons/react/Error';
import Information from '@dtsl/icons/dist/icons/react/Information';
import Success from '@dtsl/icons/dist/icons/react/Success';
import Warning from '@dtsl/icons/dist/icons/react/Warning';

// eslint-disable-next-line react/display-name
const Alert = /*#__PURE__*/forwardRef((props, ref) => {
  const [showAlert, setShowAlert] = useState(false); //this state is being used to make alert go hide and show

  const {
    type,
    heading,
    variant,
    description,
    action,
    handleCloseAlert
  } = props;

  // isActionNode tells whether the action prop is an object or a node.
  const isActionNode = /*#__PURE__*/React.isValidElement(action);
  const handleClose = () => {
    setShowAlert(false);
  };
  useImperativeHandle(ref, () => ({
    show() {
      setShowAlert(true);
    },
    hide() {
      setShowAlert(false);
    }
  }));

  //  method to close alert
  const closeAlert = event => {
    event.preventDefault();
    event.stopPropagation();
    handleClose();
    handleCloseAlert();
  };

  //  render alert icon type method
  const renderAlertTypeIcon = type => {
    switch (type) {
      case 'success':
        return /*#__PURE__*/React.createElement(Success, {
          "aria-hidden": "true",
          focusable: "false",
          className: "alert__icon--success-svg"
        });
      case 'error':
        return /*#__PURE__*/React.createElement(Error, {
          "aria-hidden": "true",
          focusable: "false",
          className: "alert__icon--error-svg"
        });
      case 'warning':
        return /*#__PURE__*/React.createElement(Warning, {
          "aria-hidden": "true",
          focusable: "false",
          className: "alert__icon--warning-svg"
        });
      default:
        return /*#__PURE__*/React.createElement(Information, {
          "aria-hidden": "true",
          focusable: "false",
          className: "alert__icon--info-svg"
        });
    }
  };
  //  render alert HTML
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
    className: styles['sib-alert-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    role: "alert",
    className: `${styles['sib-alert']} ${styles[`sib-alert--${type}`]} ${showAlert ? styles['show-alert'] : styles['hide-alert']}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['alert__progress-bar']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['alert__content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['alert__icon']
  }, renderAlertTypeIcon(type)), /*#__PURE__*/React.createElement("div", {
    className: styles['alert__text']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['alert__text--heading'],
    role: "heading",
    "aria-level": "2"
  }, heading), /*#__PURE__*/React.createElement("p", {
    className: styles['alert__text--description']
  }, description), variant === 'action' ? isActionNode ? /*#__PURE__*/React.createElement("div", {
    className: styles['alert__text--btns-wrapper']
  }, action) : /*#__PURE__*/React.createElement("div", {
    className: styles['alert__text--link-wrapper']
  }, /*#__PURE__*/React.createElement(Link, _extends({}, action, {
    className: "alert__text--link"
  }))) : null), /*#__PURE__*/React.createElement("div", {
    className: styles['alert__action']
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: closeAlert,
    className: "alert__action--close"
  }))))), document.body);
});
Alert.defaultProps = {
  heading: '',
  description: '',
  handleCloseAlert: () => {},
  action: {},
  variant: 'default'
};
Alert.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  handleCloseAlert: PropTypes.func,
  type: PropTypes.oneOf(['info', 'success', 'error', 'warning']).isRequired,
  variant: PropTypes.oneOf(['default', 'action']),
  action: PropTypes.oneOf([PropTypes.object, PropTypes.node])
};
export default Alert;